(ns common.fields.deal-fields
  (:require [common.fields.field :refer [create-field-schema]]))

(defonce heading-fields
         (let [field-schema (partial create-field-schema :deal-module/heading)]
           (merge
             (field-schema :oppo/stage
                           [:we.d/no :ta.d/yes :sa.d/yes :ex.d/no :in.d/rw]
                           {})
             (field-schema :oppo/owner
                           [:we.d/no :ta.d/yes :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/status-and-next-steps
                           [:we/no :ta.d/yes :sa.d/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/case-note
                           [:we/no :ta.d/yes :sa.d/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/link-to-pitch
                           [:we/no :ta/yes :sa/yes :ex/no :in/rw]
                           {}))))

(defonce basic-deal-information
         (let [field-schema (partial create-field-schema :deal-module/basic-information)]
           (merge
             (field-schema :oppo/name
                           [:we/no :ta.d/yes :sa.d/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/target-asset
                           [:we/no :ta.d/yes :sa.d/yes :ex.d/no :in/rw]
                           {})
             ;;TODO change into entity-association:
             ;; (field-schema :oppo/contact-person
             ;;               [:we.d/no :ta.d/yes :sa.d/yes :ex.d/no :in/rw]
             ;;               {})
             (field-schema :oppo/deal-description
                           [:we/no :ta/yes :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/deal-notes-url
                           [:we/no :ta/no :sa/no :ex.d/no :in/rw]
                           {}))))

(defonce deal-details
         (let [field-schema (partial create-field-schema :deal-module/deal-details)]
           (merge
             (field-schema :oppo/number-id
                           [:we/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/cur-capital-sought
                           [:we/no :ta/no :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/cur-ticket
                           [:we/no :ta/yes :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/cur-net-debt
                           [:we/no :ta/yes :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/cur-equity-value
                           [:we/no :ta/yes :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/stake-type
                           [:we/no :ta/yes :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/target-stake
                           [:we/no :ta/no :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/cur-round-size
                           [:we/no :ta/no :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/number-of-shares-for-us
                           [:we/no :ta/no :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/number-of-shares-total-post-deal
                           [:we/no :ta/no :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/ev-per-ebitda
                           [:we/no :ta/no :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/nd-per-ebitda
                           [:we/no :ta/no :sa/yes :ex.d/no :in/rw]
                           {})

             (field-schema :oppo/cur-pre-money
                           [:we/no :ta/no :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/cur-post-money
                           [:we/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/cur-enterprise-value
                           [:we/no :ta/no :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/cur-internal-valuation
                           [:we/no :ta/no :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/datetime-estimated-timing
                           [:we/no :ta/no :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/datetime-investment-date-actual
                           [:we/no :ta/no :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/funding-round-v2
                           [:we/no :ta/yes :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/datetime-submission-date
                           [:we/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/evaluation-and-conclusion
                           [:we/no :ta/yes :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/known-risks
                           [:we/no :ta/no :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/use-of-proceeds
                           [:we/no :ta/no :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/accessibility
                           [:we/no :ta/no :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/target-closing-time
                           [:we/no :ta/no :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/deal-priority
                           [:we/no :ta/no :sa/yes :ex.d/no :in/rw]
                           {}))))

(defonce lead-details
         (let [field-schema (partial create-field-schema :deal-module/lead-details)]
           (merge
             (field-schema :oppo/lead-type-v2
                           [:we/no :ta.d/yes :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/lead-source-v2
                           [:we/no :ta.d/yes :sa.d/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/detailed-lead-source
                           [:we/no :ta/yes :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/lead-source-comment
                           [:we/no :ta/no :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/credit
                           [:we/no :ta/yes :sa/yes :ex.d/no :in/rw]
                           {})
             ;;TODO change into entity-association:
             ;; (field-schema :oppo/lead-referrer
             ;;               [:we/no :ta.d/yes :sa/yes :ex.d/no :in/rw]
             ;;               {})
             (field-schema :oppo/lead-referrer-details
                           [:we/no :ta/no :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/funding-referrals
                           [:we/no :ta/no :sa/no :ex.d/no :in/rw]
                           {}))))

(defonce transaction
         (let [field-schema (partial create-field-schema :deal-module/transaction)]
           (merge
             (field-schema :oppo/cur-transaction-fees
                           [:we/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             ;;TODO change into entity-association:
             ;; (field-schema :oppo/buy-side-advisors
             ;;               [:we.d/no :ta/yes :sa/yes :ex.d/no :in/rw]
             ;;               {})
             ;;TODO change into entity-association:
             ;; (field-schema :oppo/sell-side-advisors
             ;;               [:we.d/no :ta/yes :sa/yes :ex.d/no :in/rw]
             ;;               {})
             (field-schema :oppo/lead-member
                           [:we/no :ta/no :sa/no :ex.d/no :in/rw]
                           {}))))

(defonce other
         (let [field-schema (partial create-field-schema :deal-module/other)]
           (merge
             (field-schema :oppo/strategic-fit
                           [:we/no :ta/no :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/rationale
                           [:we/no :ta/no :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/interaction-history
                           [:we/no :ta/no :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/how-can-we-help
                           [:we/no :ta/no :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/competetive-analysis
                           [:we/no :ta/no :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/group-companies
                           [:we/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/stake-type
                           [:we/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/lead-channel
                           [:we/no :ta/no :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/group-business-units
                           [:we/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/group-introduction-comments
                           [:we/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/cvf-team-comment
                           [:we/no :ta/no :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/value-creation-business-development
                           [:we/no :ta/no :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/value-creation-cluster-effect
                           [:we/no :ta/no :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/value-creation-corporate-governance
                           [:we/no :ta/no :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/value-creation-fundraising
                           [:we/no :ta/no :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/value-creation-government-and-regulation
                           [:we/no :ta/no :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/value-creation-recruitment
                           [:we/no :ta/no :sa/yes :ex.d/no :in/rw]
                           {})
             )))

(defonce deal-sheet-summary
         (let [field-schema (partial create-field-schema :deal-module/deal-sheet-summary)]
           (merge
             (field-schema :oppo/elevator-pitch
                           [:we/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/solving-problem
                           [:we/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/ups-solving-the-problem
                           [:we/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/five-biggest-competitors
                           [:we/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/current-phase-and-status
                           [:we/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/financing-need
                           [:we/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/kpi-targets-for-next-round
                           [:we/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/founders-and-team-description
                           [:we/no :ta/no :sa/no :ex.d/no :in/rw]
                           {}))))

(defonce opportunity-overview
         (let [field-schema (partial create-field-schema :deal-module/opportunity-overview)]
           (merge
             (field-schema :oppo/overview-competition
                           [:we/no :ta/no :sa/no :ex.d/no :in/rw]
                           {}))))

(defonce opportunity-details
         (let [field-schema (partial create-field-schema :deal-module/opportunity-details)]
           (merge
             (field-schema :oppo/asset-class
                           [:we/no :ta/yes :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/program
                           [:we/no :ta/no :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/hkstp-program
                           [:we/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             )))

(defonce rating
         (let [field-schema (partial create-field-schema :deal-module/deal-rating)]
           (merge
             (field-schema :oppo/ratings
                           [:we/no :ta/yes :sa/yes :ex.d/no :in/rw]
                           {}))))

(defonce attachments
         (let [field-schema (partial create-field-schema :deal-module/attachments)]
           (merge
             (field-schema :oppo/attachments
                           [:we.d/no :ta.d/yes :sa.d/yes :ex.d/no :in/rw]
                           {}))))

(defonce new-tag-fields
         (let [field-schema (partial create-field-schema :deal-module/tags)]
           (merge
             (field-schema :oppo/tag-aandeel
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-application
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-business
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-business-model
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-business-unit
                           [:we.d/no :ta/no :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-co-development-routing
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-company-stage
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-country
                           [:we.d/no :ta/no :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-crc-center
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-deal-category
                           [:we.d/no :ta/yes :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-deal-industry
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-deal-revenue-and-transaction-tags
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-deal-tags-investing-entity-and-operator
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-deal-type
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-disease-area
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-distributed-teams
                           [:we.d/no :ta/no :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-engagement-type
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-fintech-sub-sector
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-focus-area
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-fortum-business-area
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-functions
                           [:we.d/no :ta/no :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-fund
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-geography
                           [:we.d/no :ta/no :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-geography-new
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-goal
                           [:we.d/no :ta/no :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-hot-tags
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-if-stages
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-industrie-start-up
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-industry
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-industry-new
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-industry-segment
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-investing-entity
                           [:we.d/no :ta/yes :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-investment-theme
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-investment-thesis
                           [:we.d/no :ta/no :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-investment-type
                           [:we.d/no :ta/yes :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-kaercher-stakeholder-and-geography
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-keywords
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-lage
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-lifestage
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-location
                           [:we.d/no :ta/yes :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-nda
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-onda
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-operator
                           [:we.d/no :ta/no :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-phase
                           [:we.d/no :ta/no :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-potential-fund-investment
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-primary-tag
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-rationale
                           [:we.d/no :ta/yes :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-real-estate-sectors
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-region
                           [:we.d/no :ta/no :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-relevance-for-aic
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-secondary-tag
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-sector
                           [:we.d/no :ta/no :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-smoke
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-smoke-1
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-smoke-2
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-solution
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-source
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-species
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-sponsored-by
                           [:we.d/no :ta/no :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-stage
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-startup-format
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-strategic-focus-area
                           [:we.d/no :ta/no :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-strategy-alignment
                           [:we.d/no :ta/yes :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-sub-industry
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-subverticals
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-supply-chain
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-target-sectors
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-technologies
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-technologies
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-technology-and-business-model
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-technology-topic
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-themes
                           [:we.d/no :ta/yes :sa/yes :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-tvc-dd-funnel
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-type-of-investment
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-type-of-technology
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-vertical-subvertical
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-dash
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-verticals
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             (field-schema :oppo/tag-hitachi-project
                           [:we.d/no :ta/no :sa/no :ex.d/no :in/rw]
                           {})
             )))

(def buy-side-guest-fields
  (let [field-schema (partial create-field-schema :deal-module/guests)]
    (merge
      (field-schema :role/guest-buy-side
                    [:we.d/no :ta.d/yes :sa.d/yes :ex.d/no :in.d/no]
                    {}))))

(defonce schema
         (merge heading-fields
                buy-side-guest-fields
                basic-deal-information
                deal-details
                lead-details
                transaction
                other
                deal-sheet-summary
                opportunity-overview
                opportunity-details
                rating
                new-tag-fields
                attachments))
